import { render, staticRenderFns } from "./order_deliver_edit.vue?vue&type=template&id=19d0d2b8&scoped=true"
import script from "./order_deliver_edit.vue?vue&type=script&lang=js"
export * from "./order_deliver_edit.vue?vue&type=script&lang=js"
import style0 from "./order_deliver_edit.vue?vue&type=style&index=0&id=19d0d2b8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d0d2b8",
  null
  
)

export default component.exports